// extracted by mini-css-extract-plugin
export default {"imageWrapper":"sH-z","hovered":"tH-z","hoverImage":"uH-z","mainImage":"vH-z","imageNoBackground":"wH-z","fullSizeImage":"xH-z"};